import { getColorTones } from '../../../utils';
import { brandColors } from './brand';

export const brandToneColors = {
  ...getColorTones(brandColors.brandOne, 'brandOne'),
  ...getColorTones(brandColors.brandTwo, 'brandTwo'),
} as const;
